/**
 * Resolve dropdown option from a cell value (string code or autocomplete object).
 * Used so column.unit(rowId, rowData) can show the correct UoM while editing before save.
 */
export function findDropdownOptionForRowField(options, fieldValue) {
  if (!Array.isArray(options) || fieldValue == null) return null;

  const candidates = [];
  if (typeof fieldValue === "string") {
    const s = fieldValue.trim();
    if (s) candidates.push(s);
  } else if (typeof fieldValue === "object" && fieldValue && !fieldValue.isCategory) {
    [
      fieldValue.code,
      fieldValue.value,
      fieldValue.id,
      fieldValue.name,
      fieldValue.title,
      fieldValue.dropdown,
      fieldValue.dropdown_en,
    ].forEach(
      (x) => {
        if (x != null && String(x).trim() !== "") candidates.push(String(x).trim());
      }
    );
  } else {
    candidates.push(String(fieldValue));
  }

  for (const c of candidates) {
    const hit = options.find(
      (opt) =>
        opt &&
        !opt.isCategory &&
        (String(opt.code) === c ||
          String(opt.value) === c ||
          String(opt.id) === c ||
          (opt.name != null && String(opt.name) === c) ||
          (opt.title != null && String(opt.title) === c) ||
          (opt.dropdown != null && String(opt.dropdown) === c) ||
          (opt.dropdown_en != null && String(opt.dropdown_en) === c))
    );
    if (hit) return hit;
  }
  return null;
}

/**
 * Prefer unit from current row field + dropdown; fall back to per-row cache (e.g. after GET).
 */
export function unitFromDropdownOrCache(
  rowData,
  fieldName,
  options,
  unitByRowId,
  rowId,
  fallback = "unit"
) {
  const fieldVal = rowData?.[fieldName];
  // Category dropdowns often store the full option object on select — use its unit even if
  // `options` in the column closure is still empty or stale.
  if (
    fieldVal &&
    typeof fieldVal === "object" &&
    !fieldVal.isCategory &&
    fieldVal.unit != null &&
    fieldVal.unit !== ""
  ) {
    return fieldVal.unit;
  }
  const opt = findDropdownOptionForRowField(options, fieldVal);
  if (opt?.unit != null && opt.unit !== "") return opt.unit;
  return unitByRowId?.[rowId] ?? fallback;
}

/** Ingoing/outgoing transport: shorten combined unit label for display. */
export function formatIngoingTransportQtyUnit(raw) {
  if (raw == null || raw === "") return "unit";
  const s = String(raw);
  return s.includes(".km") ? s.slice(0, 3) : s.slice(0, 2);
}

export function transportMeansUnitFromRow(
  rowData,
  dropdownUsedFor,
  unitMaterials,
  rowId,
  meansFieldName = "means_transportation"
) {
  const opt = findDropdownOptionForRowField(
    dropdownUsedFor,
    rowData?.[meansFieldName]
  );
  const raw = opt?.unit ?? unitMaterials?.[rowId];
  return formatIngoingTransportQtyUnit(raw);
}
